const middleware = {}

middleware['authenticated'] = require('../middleware/authenticated.js')
middleware['authenticated'] = middleware['authenticated'].default || middleware['authenticated']

middleware['debug'] = require('../middleware/debug.js')
middleware['debug'] = middleware['debug'].default || middleware['debug']

export default middleware
